/**
 * Aviso al salir del Creador con cambios sin guardar.
 * El Creador registra cómo saber si hay cambios; la navegación de la app
 * (NavigationContext) pregunta antes de cambiar de vista. Una confirmación
 * aceptada vale unos instantes para que una misma salida no pregunte dos veces.
 */

let dirtyCheck = null;
let approvedAt = 0;
const APPROVAL_WINDOW_MS = 800;

/** El Creador registra (o quita, con null) la función que dice si hay cambios sin guardar. */
export function setCreatorDirtyCheck(fn) {
    dirtyCheck = typeof fn === 'function' ? fn : null;
}

/** true si se puede salir: no hay cambios pendientes o el usuario confirmó descartarlos. */
export function confirmLeaveCreator() {
    if (!dirtyCheck || !dirtyCheck()) return true;
    if (Date.now() - approvedAt < APPROVAL_WINDOW_MS) return true;
    const ok = window.confirm('Tienes cambios sin guardar en el Creador. ¿Salir y descartarlos?');
    if (ok) approvedAt = Date.now();
    return ok;
}
